// extracted by mini-css-extract-plugin
module.exports = {"Container":"Review_Container__20180","heading":"Review_heading__gXeGI","subContainer":"Review_subContainer__1S09x"};